<div [ngClass]="{'detail-relationships': config.expandable && !config.checkable}"
    (contextmenu)="mouseRightClickOnPanel($event)" class="detail-relationships-container">
    <ng-container>
        <kendo-treeview tid="relationship_tree" class="container" [nodes]="config.nodes" [textField]="config.showAs"
            (checkedChange)="onCheckedChange($event)" (nodeClick)="onNodeClick($event)"
            (nodeDblClick)="onNodeDblClick($event)" kendoTreeViewFlatDataBinding
            [kendoTreeViewCheckable]="checkableSettings" checkBy="uuid" [(checkedKeys)]="config.checkedKeys"
            (checkedKeysChange)="onCheckedKeysChange()" [children]="children" [hasChildren]="hasChildren"
            [isExpanded]="isExpanded" (collapse)="handleCollapse($event)" (expand)="handleExpand($event)" idField="uuid"
            parentIdField="parentId">
            <ng-template kendoTreeViewNodeTemplate let-dataItem>
                <div (touchstart)="ontouchstart($event)" (touchend)="ontouchend($event, dataItem)"
                    *ngIf="config.showAs === 'shortName' || !config.showAs"
                    (contextmenu)="mouseRightClick($event,dataItem)" [contextMenuValue]="dataItem">
                    {{dataItem.shortName}}
                </div>
                <div (touchstart)="ontouchstart($event)" (touchend)="ontouchend($event, dataItem)"
                    (contextmenu)="mouseRightClick($event,dataItem)" *ngIf="config.showAs === 'name'"
                    [contextMenuValue]="dataItem">
                    {{dataItem.name}}
                </div>
            </ng-template>
        </kendo-treeview>
    </ng-container>
</div>

<context-menu #contextItemMenu>
    <ng-template contextMenuItem (execute)="onMenuSelect($event)" *ngIf="config.checkable && config.expandable">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)"
            tid="view_research">
            <div class='empty'></div>
            <span class="title">View Research</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)"
            tid="view_details">
            <div class='empty'></div>
            <span class="title">View Details</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)" *ngIf="isEditDetailsShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)"
            tid="edit_details">
            <div class='empty'></div>
            <span class="title">Edit Details</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)" tid="new_note">
            <div class='empty'></div>
            <span class="title">New Note</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem divider="true"></ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" [subMenu]="screenSubMenu" *ngIf="isChangeTypeMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)"
            tid="change_relationship_type">
            <div class='empty'></div>
            <span class="title">Change Type</span>
        </div>
        <smart-icon name="angle-right" class="angle-right" tid="change_type"></smart-icon>
    </ng-template>
    <context-menu #screenSubMenu>
        <ng-template contextMenuItem *ngFor="let subMenu of selectedItemValidRelationshipType; trackBy:trackByFn"
            (execute)="changeRelationshipType($event,subMenu)">
            <div class="screen-sub-menu-container" (mousedown)="onClick($event)" (click)="onClick($event)"
                tid="change_item_type">
                <span>{{subMenu.caption}}</span>
            </div>
        </ng-template>
    </context-menu>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isRemoveRelationshipMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)"
            tid="remove_relationship">
            <div class='empty'></div>
            <span class="title">Remove Relationship</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem divider="true" *ngIf="isChangeTypeMenuShow || isRemoveRelationshipMenuShow">
    </ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isAddEntityMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty'></div>
            <span class="title">Add Entity</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isAddContactMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty'></div>
            <span class="title">Add Contact</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem divider="true" *ngIf="isAddEntityMenuShow || isAddContactMenuShow"></ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isEditTeamMemberMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty'></div>
            <span class="title">Edit Team Members</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem divider="true" *ngIf="isEditTeamMemberMenuShow"></ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)"
            tid="show_as_shortname">
            <div class='empty' *ngIf="!showAsShortNameChecked"></div>
            <smart-icon *ngIf="showAsShortNameChecked" name="check" class="checkIcon"></smart-icon>
            <span class="title">Show as Shortname</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)"
            tid="show_as_name">
            <div class='empty' *ngIf="!showAsNameChecked"></div>
            <smart-icon *ngIf="showAsNameChecked" name="check" class="checkIcon"></smart-icon>
            <span class="title">Show as Name</span>
        </div>
    </ng-template>
</context-menu>

<!-- relationship type context menu-->
<context-menu #relationshipTypeContextMenu>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isAddEntityMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty'></div>
            <span class="title">Add Entity</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isAddContactMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty'></div>
            <span class="title">Add Contact</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem divider="true"></ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isEditTeamMemberMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty'></div>
            <span class="title">Edit Team Members</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem divider="true" *ngIf="isEditTeamMemberMenuShow"></ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isRemoveAllRelationshipMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)"
            tid="remove_all_type">
            <div class='empty'></div>
            <span class="title">Remove All of This Type</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem divider="true" *ngIf="isRemoveAllRelationshipMenuShow"></ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty' *ngIf="!showAsShortNameChecked"></div>
            <smart-icon *ngIf="showAsShortNameChecked" name="check" class="checkIcon"></smart-icon>
            <span class="title">Show as Shortname</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty' *ngIf="!showAsNameChecked"></div>
            <smart-icon *ngIf="showAsNameChecked" name="check" class="checkIcon"></smart-icon>
            <span class="title">Show as Name</span>
        </div>
    </ng-template>
</context-menu>

<!-- relationship panel's context menu-->
<context-menu #relationshipPanelContextMenu>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isAddEntityMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty'></div>
            <span class="title">Add Entity</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isAddContactMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty'></div>
            <span class="title">Add Contact</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem divider="true" *ngIf="isAddEntityMenuShow || isAddContactMenuShow"></ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)"
        *ngIf="isEditTeamMemberMenuShow">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty'></div>
            <span class="title">Edit Team Members</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem divider="true" *ngIf="isEditTeamMemberMenuShow"></ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty' *ngIf="!showAsShortNameChecked"></div>
            <smart-icon *ngIf="showAsShortNameChecked" name="check" class="checkIcon"></smart-icon>
            <span class="title">Show as Shortname</span>
        </div>
    </ng-template>
    <ng-template contextMenuItem let-item="contextMenuValue" (execute)="onMenuSelect($event)">
        <div class="screen-menu-item-container" (mousedown)="onClick($event)" (click)="onClick($event)">
            <div class='empty' *ngIf="!showAsNameChecked"></div>
            <smart-icon *ngIf="showAsNameChecked" name="check" class="checkIcon"></smart-icon>
            <span class="title">Show as Name</span>
        </div>
    </ng-template>
</context-menu>